import React, { useState } from 'react';
import confirm from '@/page/components/confirm';
import { Input, Button, message } from 'antd';
import API from '@/api/api';

export default function (props) {
    const { itemList, circleId, showManage } = props;
    const [myList, setMyList] = useState(itemList);
    const [newItem, setNewItem] = useState('');
    const [editItemId, setEditItemId] = useState('');
    const [editItemName, setEditItemName] = useState('');
    async function addItem() {
        const result = await API.itemEdit({ circleId, itemName: newItem });
        if (!result) return;
        if (result.status === '1') {
            setMyList(myList.concat({ itemId: result.data.itemId, itemName: newItem }));
        } else {
            message.error(result.msg);
        }
    }
    const deleteItem = async itemId => {
        if (!await confirm('确定删除栏目吗？')) {
            showManage(myList);
            return;
        }
        const result = await API.itemDelete({ circleId, itemId });
        if (!result) return;
        if (result.status === '1') {
            showManage(myList.filter(o => o.itemId !== itemId));
        } else {
            message.error(result.msg);
        }
    }
    const doEditItem = ({ itemId, itemName }) => {
        setEditItemId(itemId);
        setEditItemName(itemName);
    }
    const saveItem = async () => {
        const result = await API.itemEdit({ circleId, itemId: editItemId, itemName: editItemName });
        if (!result) return;
        if (result.status === '1') {
            myList.find(o => o.itemId === editItemId).itemName = editItemName;
            setMyList(myList);
            setEditItemId('');
        } else {
            message.error(result.msg);
        }
    }
    return (
        <div>
            <div style={{ display: 'flex', marginBottom: '10px' }}>
                <Input value={newItem} style={{ width: '240px' }} onChange={event => setNewItem(event.target.value)} />
                <Button style={{ marginLeft: '10px' }} onClick={addItem}>添加</Button>
            </div>
            {
                myList.map(o =>
                    editItemId === o.itemId ?
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }} key={o.itemId}>
                            <Input value={editItemName} style={{ width: '240px' }}
                                onChange={e => setEditItemName(e.target.value)} />
                            <div style={{ flexShrink: 0 }}>
                                <Button type='link' onClick={saveItem}>保存</Button>
                                <Button type='link' onClick={() => setEditItemId('')}>取消</Button>
                            </div>
                        </div> :
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }} key={o.itemId}>
                            <div>{o.itemName}</div>
                            <div style={{ flexShrink: 0 }}>
                                <Button type='link' onClick={() => doEditItem(o)}>编辑</Button>
                                <Button type='link' onClick={() => deleteItem(o.itemId)}>删除</Button>
                            </div>
                        </div>
                )
            }
        </div>
    )
}